<template>
  <!-- Phones only (touch screen AND narrow): Rally Navigator is a desktop app, so tell
       phone visitors to open the page on their computer and let them copy the link.
       CSS-only targeting, so it's correct in the prerendered HTML with no flicker;
       tablets and computers never see it. Text is props for translated pages. -->
  <div
    class="hidden [@media(pointer:coarse)_and_(max-width:767px)]:block mx-auto my-4 max-w-[560px] bg-[#1a1a1a] border-2 border-[#FF0000] rounded-2xl p-4 font-helvetica text-center"
    role="note"
  >
    <p class="text-white text-[16px] font-bold leading-snug">
      {{ message }}
    </p>
    <button
      type="button"
      class="mt-3 inline-flex items-center gap-2 font-bold text-white text-[16px] bg-[#262626] border-2 border-[#FF0000] rounded-full px-6 py-3"
      @click="copy"
    >
      {{ copied ? copiedLabel : copyLabel }}
    </button>
    <p class="text-[#999999] text-[13px] mt-2 break-all">{{ url }}</p>
  </div>
</template>

<script>
export default {
  name: 'PhoneDownloadNotice',
  props: {
    message: {
      type: String,
      default:
        'Rally Navigator is a desktop app for Windows, Mac and Linux. Open this page on your computer to download.',
    },
    copyLabel: { type: String, default: 'Copy Link' },
    copiedLabel: { type: String, default: 'Link Copied ✓' },
    url: { type: String, default: 'https://www.rallynavigator.com/download' },
  },
  data() {
    return { copied: false };
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.url);
      } catch (e) {
        // Older in-app browsers: fall back to a temporary text field.
        const t = document.createElement('textarea');
        t.value = this.url;
        t.setAttribute('readonly', '');
        t.style.position = 'absolute';
        t.style.left = '-9999px';
        document.body.appendChild(t);
        t.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          /* the URL is still shown under the button for manual copying */
        }
        document.body.removeChild(t);
      }
      this.copied = true;
      setTimeout(() => (this.copied = false), 2500);
      if (window.gtag) window.gtag('event', 'download_link_copied', { page_path: window.location.pathname });
    },
  },
};
</script>
